import { render, staticRenderFns } from "./ChangePolicyPaperless.vue?vue&type=template&id=6be38873"
import script from "./ChangePolicyPaperless.vue?vue&type=script&lang=js"
export * from "./ChangePolicyPaperless.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports